import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, Injectable, NgModule, ApplicationRef } from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatNativeDateModule} from '@angular/material/core';
import {AppConfig} from './app.config';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HttpConfigInterceptor} from './httpconfig.interceptor';
import {NotificationsComponent} from './notifications/notifications.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {WitsService} from './services/wits.service';
import {UnitParseModule} from './pipes/unit-parse.module';

import {StreamErrorsComponent} from './stream-errors/stream-errors.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {NgxLocalstorageDirectiveModule} from 'ngx-localstorage';
import {CoreModule} from './core/core.module';
import {OnlineStatusModule} from 'ngx-online-status';
import {Socket} from 'ngx-socket-io';
import {environment} from '../environments/environment';
import {PromptUpdateService} from './services/prompt-update.service';
import { RoleAccessModule } from './shared/role-access.module';

@Injectable()
export class ChatSocket extends Socket {
  constructor(appRef: ApplicationRef) {
    super({ url: `${environment.nodeServer}/chat`, options: {} }, appRef);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    NotificationsComponent,
    StreamErrorsComponent
  ],
  imports: [
    MatDialogModule,
    BrowserModule,
    MatSnackBarModule,
    HttpClientModule,
    MatNativeDateModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxLocalstorageDirectiveModule,
    CoreModule,
    MatProgressBarModule,
    UnitParseModule,
    MatButtonModule,
    MatIconModule,
    OnlineStatusModule,
    RoleAccessModule,
  ],
  providers: [
    /*!environment.env ? [] : {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },*/
    WitsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    /*{provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true},*/
    ChatSocket,
    AppConfig,
    PromptUpdateService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
